import { useShouldShowDevTeamFeature } from './_base';

export const useEventBucketsFeature: () => boolean = useShouldShowDevTeamFeature;
